import { render } from "./ColsIcon.vue?vue&type=template&id=7337f2fe"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/ColsIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7337f2fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7337f2fe', __exports__)) {
    api.reload('7337f2fe', __exports__)
  }
  
  module.hot.accept("./ColsIcon.vue?vue&type=template&id=7337f2fe", () => {
    api.rerender('7337f2fe', render)
  })

}


export default __exports__